<template>
    <div class="batch">
        <car-headerbar :title="title" :isCustomLeft="isCustomLeft"/>
        <CarsForm
            ref="dcDynamicForm"
            :model="model"
            :configData="configData"
            @submitAction="confirm"
            @afterRead="afterRead"
            @addEventListenerForInput="addEventListenerForInput"
            @removeEventListenerForInput="removeEventListenerForInput"
        ></CarsForm>
    </div>
</template>
<script>
import CarsForm from 'imc-mobile/src/component/form'
import CarBatchIncrease from 'imc-mobile/src/component/batchIncrease'
import batchLabel from '../compontents/label.vue'
import { Questionnaire } from '@/network'
import { parseQueryString } from '@/util/common'
import { removeClass2 } from '@/util/status-util'
import { getStorage, setStorage } from '@/util/common'
import browser from '@/util/browser'

export default {
    name: 'checkboxOptionSet',
    components: { CarsForm, CarBatchIncrease },
    data() {
        return {
            title: '选项设置',
            model: {
                required: true, // 默认选中
                leastChoose: '不限制',
                mostChoose: '不限制',
                batchIncrease: [{
                    value: '',
                    type: 1,
                },
                {
                    value: '',
                    type: 1,
                }],
            },
            configData: {
                form: {
                    groupData: [],
                    button: { disabled: false, text: '确定', api: 'button' },
                },
                api: {
                    request: {
                        submit: {
                            url: '',
                            method: 'post',
                        },
                    },
                },
            },
            tid: parseQueryString().tid,
            isCustomLeft: false,
            addPadding: false,
            editStatus: false,
        }
    },
    created() {
        removeClass2('body', 'loading')
        const { guaguaApp } = browser
        this.isCustomLeft = guaguaApp
        this.initData()
    },
    computed: {
        pageId() {
            return this.$route.params.pageId
        },
        topicId() {
            return this.$route.params.topicId
        },
    },
    methods: {
        initData() {
            this.configData.form.groupData.push({
                type: 'group', // 分组
                label: '设置选项',
                code: 'group1',
                items: [{
                    code: 'picker',
                    label: '添加图片',
                    type: 'uploader',
                    itemProps: {
                        column: 'horizontal',
                    },
                    props: {
                        disabled: this.editStatus,
                    }
                }]}
            )
            this.configData.form.groupData.push({
                type: 'group', // 分组
                label: '设置子选项',
                code: 'group2',
                items: [{
                    code: 'leastChoose',
                    label: '子选项最少选择',
                    type: 'picker',
                    placeholder: '不限制',
                    props: {
                        readonly: this.editStatus,
                        columns: [
                            {
                                'text': '不限制',
                                'value': '不限制',
                            }, {
                                'text': '1项',
                                'value': 1,
                            }, {
                                'text': '2项',
                                'value': 2,
                            }, {
                                'text': '3项',
                                'value': 3,
                            }, {
                                'text': '4项',
                                'value': 4,
                            }, {
                                'text': '5项',
                                'value': 5,
                            }, {
                                'text': '6项',
                                'value': 6,
                            }, {
                                'text': '7项',
                                'value': 7,
                            }, {
                                'text': '8项',
                                'value': 8,
                            }, {
                                'text': '9项',
                                'value': 9,
                            }, {
                                'text': '10项',
                                'value': 10,
                            }, {
                                'text': '11项',
                                'value': 11,
                            }, {
                                'text': '12项',
                                'value': 12,
                            }, {
                                'text': '13项',
                                'value': 13,
                            }, {
                                'text': '14项',
                                'value': 14,
                            }, {
                                'text': '15项',
                                'value': 15,
                            }
                        ],
                        rightIcon: 'arrow',
                    },
                    itemProps: {
                        column: 'horizontal',
                    },
                }, {
                    code: 'mostChoose',
                    label: '子选项最多选择',
                    type: 'picker',
                    placeholder: '不限制',
                    props: {
                        readonly: this.editStatus,
                        columns: [
                            {
                                'text': '不限制',
                                'value': '不限制',
                            }, {
                                'text': '1项',
                                'value': 1,
                            }, {
                                'text': '2项',
                                'value': 2,
                            }, {
                                'text': '3项',
                                'value': 3,
                            }, {
                                'text': '4项',
                                'value': 4,
                            }, {
                                'text': '5项',
                                'value': 5,
                            }, {
                                'text': '6项',
                                'value': 6,
                            }, {
                                'text': '7项',
                                'value': 7,
                            }, {
                                'text': '8项',
                                'value': 8,
                            }, {
                                'text': '9项',
                                'value': 9,
                            }, {
                                'text': '10项',
                                'value': 10,
                            }, {
                                'text': '11项',
                                'value': 11,
                            }, {
                                'text': '12项',
                                'value': 12,
                            }, {
                                'text': '13项',
                                'value': 13,
                            }, {
                                'text': '14项',
                                'value': 14,
                            }, {
                                'text': '15项',
                                'value': 15,
                            }
                        ],
                        rightIcon: 'arrow',
                    },
                    itemProps: {
                        column: 'horizontal',
                    },
                }],
            })
        },
        afterRead(file, index) {
            var formData = new FormData()
            formData.append('file', file.file)
            formData.append('tid', this.tid)
            addClass2('body', 'loading')
            Questionnaire.upload(formData, this.tid).then((res) => {
                let { data: { data } } = res
                let obj = this.model.batchIncrease[index]
                obj = {...obj, ...data}
                this.model.batchIncrease.splice(index, 1, obj)
                removeClass2('body', 'loading')
            })
        },
        // 移动端输入时键盘弹起
        addEventListenerForInput() {
            const isAndroid = /android/i.test(window.navigator.userAgent)
            if (isAndroid) {
                const refTextarea = this.$refs.textarea.$el
                const st = document.documentElement.scrollTop || document.body.scrollTop
                const ot = refTextarea.offsetTop
                const ob = window.innerHeight - ot + st - refTextarea.offsetHeight
                const keyH = 400; //软键盘的高度
                this.addPadding = true
                // if (ob < keyH) {
                //     this.$nextTick(() => {
                //         document.documentElement.scrollTop = st + keyH - ob
                //         document.body.scrollTop = st + keyH - ob
                //     })
                // }
            }
        },
        removeEventListenerForInput() {
            const isAndroid = /android/i.test(window.navigator.userAgent)
            if (isAndroid) {
                this.addPadding = false
            }
        },
        confirm() {
            debugger
            this.$router.back({
                name: 'topic2',
                params: {
                    pageId: this.pageId,
                    topicId: this.topicId,
                },
            })
        },
    }   
}
</script>
<style scoped>
    
</style>
